export class LicenseEditTransferDetailsRequest {
    ID: number;
    TransferDisabled: boolean;
    TransferDisabledReason: string;
    TransferLimitMax: number;
    TransferLimitInTimeMinutes: number;
    Note: string;
    TransferLimitPCs?: number;
}
